export const footerEventsConfig = {
    parentSelector: '.footer',
    events: {
        // Footer link clicks
        footerLinks: {
            selector: '.footer-block__details-content a.link--text, .footer__list-social a.link',
            event: {
                event: 'user_interaction',
                component: 'footer',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const parentBlock = element.closest('.footer-block');
                    const field = parentBlock ? parentBlock.querySelector('.footer-block__heading')?.textContent.trim() : 'Quick links';
                    return {
                        field: field,
                        link_text: element.textContent.trim(),
                        link_url: element.href
                    };
                }
            }
        },

        // Phone number click
        footerPhone: {
            selector: 'a[href^="tel:"]',
            event: {
                event: 'user_interaction',
                component: 'footer',
                element: 'phone',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    field: 'DCP bv',
                    action_value: element.textContent.trim()
                })
            }
        },

        // Country/region dropdown events
        countryDropdown: {
            selector: '.localization-form__select[aria-describedby="FooterCountryLabel"]',
            events: {
                open: {
                    event: 'user_interaction',
                    component: 'footer',
                    element: 'dropdown',
                    field: 'Country/region',
                    action: 'open',
                    trigger: 'click'
                },
                close: {
                    event: 'user_interaction',
                    component: 'footer',
                    element: 'dropdown',
                    field: 'Country/region',
                    action: 'close',
                    trigger: 'blur'
                },
                select: {
                    selector: '.disclosure__link[data-value]',
                    event: {
                        event: 'user_interaction',
                        component: 'footer',
                        element: 'dropdown',
                        field: 'Country/region',
                        action: 'select',
                        trigger: 'click',
                        getDynamicData: (element) => ({
                            select_value: element.querySelector('.country')?.textContent.trim()
                        })
                    }
                }
            }
        },

        // Language dropdown events
        languageDropdown: {
            selector: '.localization-form__select[aria-describedby="FooterLanguageLabel"]',
            events: {
                open: {
                    event: 'user_interaction',
                    component: 'footer',
                    element: 'dropdown',
                    field: 'Language',
                    action: 'open',
                    trigger: 'click'
                },
                close: {
                    event: 'user_interaction',
                    component: 'footer',
                    element: 'dropdown',
                    field: 'Language',
                    action: 'close',
                    trigger: 'blur'
                },
                select: {
                    selector: '.disclosure__link[data-value]',
                    event: {
                        event: 'user_interaction',
                        component: 'footer',
                        element: 'dropdown',
                        field: 'Language',
                        action: 'select',
                        trigger: 'click',
                        getDynamicData: (element) => ({
                            select_value: element.textContent.trim()
                        })
                    }
                }
            }
        },

        // Newsletter form events
        newsletterForm: {
            selector: 'form[data-form-root="true"]',
            events: {
                focus: {
                    selector: 'input[type="email"]',
                    event: {
                        event: 'form',
                        component: 'newsletter',
                        element: 'text_field',
                        field: 'Email',
                        action: 'focus',
                        trigger: 'focus'
                    }
                },
                error: {
                    selector: 'input[type="email"]',
                    event: {
                        event: 'form',
                        component: 'newsletter',
                        element: 'text_field',
                        field: 'Email',
                        action: 'error',
                        trigger: 'blur',
                        getDynamicData: (element) => {
                            const errorMessage = element.closest('.field')?.querySelector('.bss-message')?.textContent.trim();
                            return errorMessage ? {
                                error_message: errorMessage
                            } : null;
                        }
                    }
                },
                submit: {
                    event: {
                        event: 'form',
                        component: 'newsletter',
                        element: 'form',
                        action: 'submit',
                        trigger: 'submit',
                        getDynamicData: (element) => ({
                            action_value: element.checkValidity() ? 'valid' : 'invalid'
                        })
                    }
                }
            }
        }
    }
}; 